import { Party } from '../../../../users/components/user-details/models/user-details-form';

// A party from GET /parties that carries the surrogate id. `assignments[].partyId` is that id —
// NOT the customer `number`, which is what the party rows display — so a party can only be
// assigned once we have it.
export type AssignableParty = Party & { id: number };

// `Party.id` is optional (see the note on the interface), so this narrows the search results to
// the ones that can actually be posted. In practice /parties always returns an id; anything
// without one is dropped from the results rather than offered and then rejected at save time.
export function isAssignable(party: Party): party is AssignableParty {
  return typeof party.id === 'number';
}
